import getUrlForEnv, { services } from "@irati/utils/endpoints/getUrlForEnv";
var endpoints = {
    image: function (imageId) { return getUrlForEnv(services.IMAGES_SERVICE, "/v1/images/" + imageId); },
    images: function () { return getUrlForEnv(services.IMAGES_SERVICE, "/v1/images"); }
};
export default endpoints;
